import GenerateForm from '../components/GenerateForm';

function GeneratePage() {
  return (
    <section className="card hero">
      <div className="hero-text">
        <p className="eyebrow">Lead intelligence</p>
        <h1>Generate a clean CSV in seconds.</h1>
        <p className="muted">
          Pull fresh agencies from Google Places, filter by reviews, and download the CSV ready for campaign upload.
        </p>
      </div>
      <GenerateForm />
    </section>
  );
}

export default GeneratePage;
